module.exports = __webpack_public_path__ + "media/src/assets/Images/ContactIcon-dcdee251b5abb9ead1de8aa8a5938857.svg";